import ApiService2 from "@/helpers/api.service.ext";
const API2 = new ApiService2();
const NOTIF_ENDPOINT = "/peddlr-notif";
// import moment from "moment";

export const state = {
  peddlrNotifications: [],
  peddlrNotificationPageInfo: {
    total: 0,
  },
  peddlrNotificationDetails: {},
  peddlrNotificationModules: [],
  errors: null,
};

export const mutations = {
  UPDATE_PEDDLR_NOTIFICATIONS(state, list) {
    state.peddlrNotifications = list;
  },
  UPDATE_PEDDLR_NOTIFICATIONS_INFO(state, total) {
    state.peddlrNotificationPageInfo.total = total;
  },
  UPDATE_PEDDLR_NOTIFICATION_DETAILS(state, value) {
    state.peddlrNotificationDetails = value;
  },
  UPDATE_PEDDLR_NOTIFICATION_MODULES(state, list) {
    state.peddlrNotificationModules = list;
  },
  SET_PROD_ERRORS(state, errors) {
    state.errors = errors;
  },
};

export const actions = {
  listPeddlrNotification(context, params) {
    return new Promise((resolve, reject) => {
      API2.post(`${NOTIF_ENDPOINT}/list`, params)
        .then(({ data }) => {
          context.commit("UPDATE_PEDDLR_NOTIFICATIONS", data.message.rows);
          context.commit("UPDATE_PEDDLR_NOTIFICATIONS_INFO", data.message.pageInfo.total);
          resolve();
        })
        .catch(({ response }) => {
          context.commit("SET_PROD_ERRORS", response.message);
          reject();
        });
    });
  },
  getPeddlrNotificationDetails(context, params) {
    return new Promise((resolve, reject) => {
      API2.post(`${NOTIF_ENDPOINT}/details`, params)
        .then(({ data }) => {
          context.commit("UPDATE_PEDDLR_NOTIFICATION_DETAILS", data.message);
          resolve();
        })
        .catch(({ response }) => {
          context.commit("SET_PROD_ERRORS", response.message);
          reject();
        });
    });
  },
  notificationAction(context, params) {
    return new Promise((resolve, reject) => {
      API2.post(`${NOTIF_ENDPOINT}/${params.action}`, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("SET_PROD_ERRORS", response.message);
          reject();
        });
    });
  },
  listPeddlrNotificationModules(context, params) {
    return new Promise((resolve, reject) => {
      API2.get(`${NOTIF_ENDPOINT}/list-modules`, params)
        .then(({ data }) => {
          context.commit("UPDATE_PEDDLR_NOTIFICATION_MODULES", data.message.rows);
          resolve();
        })
        .catch(({ response }) => {
          context.commit("SET_PROD_ERRORS", response.message);
          reject();
        });
    });
  },
};
